/* eslint-disable no-loop-func */
import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    allPages: null,
    currentPage: null,
    currentPath: window.location.pathname,
    currentPageType: 'cms',
    resultsPageId: 16,
    villaPageId: 27,
    experiencePageId: 661,
    experienceGroupPageId: 1046,
    pressPageId: 773,
    blogArticlePageId: 1050,
    blogTagHomePageId: 1051,
    loginPageId: 79,
    mysubscriptionsPageId: 84,
    villaPayDepositPayThanksPage: 1082,
    villaPayBalancePayThanksPage: 1083,
    dashboardPageId: 82,
    collectionData: null,
  },
  getters: {
    allPages: (state) => state.allPages,
    currentPath: (state) => state.currentPath,
    currentPageType: (state) => state.currentPageType,
    currentPageAncesstors: (state, getters) => {
      const ancestors = [];
      if (getters.currentPage && getters.allPages) {
        let parent = getters.allPages.find((o) => o.id === getters.currentPage.parentPageId);
        while (parent && parent.languageSpecificCollection) {
          const pls = parent.languageSpecificCollection[0];
          ancestors.unshift({
            id: parent.id,
            title: pls.menuName,
            path: (parent.paths ? parent.paths[0].path : ''),
          });
          parent = getters.allPages.find((o) => o.id === parent.parentPageId);
        }
        return ancestors;
      }
    },
    currentPage: (state, getters) => {
      if (state.currentPage) {
        return state.currentPage;
      }
    },
    // Current Page language specific data
    currentPageLS: (state, getters) => {
      if (state.currentPage) {
        return state.currentPage.languageSpecificCollection[0];
      }
    },
    currentLang: (state, getters) => {
      const p = getters.currentPath;
      if (p.startsWith('/fr/') || p.endsWith('/fr')) {
        return 'fr';
      } if (p.startsWith('/de/') || p.endsWith('/de')) {
        return 'de';
      }
      return 'en';
    },
    currentLangId: (state, getters) => {
      const lang = getters.currentLang;
      if (lang == 'en') {
        return 1;
      } if (lang == 'fr') {
        return 2;
      }
      return 3;
    },
    getPageById: (state, getters) => (id) => {
      if (state.allPages) {
        return state.allPages.find((o) => o.id === id);
      }
    },
    getPageURLById: (state, getters) => (id) => {
      const page = getters.getPageById(Number(id));
      if (page) {
        let path = page.paths[0].path;
        path = (getters.currentLang !== 'en' ? `/${getters.currentLang}` : '') + path;
        path = path === '' ? '/' : path;
        return path;
      }
    },
    getPageByURL: (state, getters) => (url) => {
      let rp = null;
      if (state.allPages) {
        state.allPages.forEach((page, key) => {
          if (page.paths.find((p) => p.path === url)) {
            rp = page;
          }
        });
      }
      return rp;
    },
    getPageMenuNameById: (state, getters) => (id) => {
      const page = getters.getPageById(Number(id));
      if (page) {
        return page.languageSpecificCollection[0].menuName;
      }
    },
    isCurrentPageSecure: (state, getters) => {
      if ((getters.currentPage && getters.currentPage.id === state.loginPageId)
        || (getters.currentPageAncesstors &&
        getters.currentPageAncesstors.find((a) => a.id === state.loginPageId)
        &&
        !getters.currentPageAncesstors.find((a) => a.id === 80) // but not inside OB funnel
        &&
        getters.currentPage.id != state.mysubscriptionsPageId // and not on My Subscriptions page (for one-click sub/unsub and token access. Subs page will check for token access if not logged in,
        &&
        getters.currentPage.id != state.villaPayDepositPayThanksPage // and not on Villa Post Payment thank you pages
        &&
        getters.currentPage.id != state.villaPayBalancePayThanksPage // and not on Villa Post Payment thank you pages
      // if token access fails it will redirect to login page)
        )) return true;
      return false;
    },
    getCollectionData: (state) => state.collectionData,
  },
  mutations: {
    setCurrentPath(state, data) {
      state.currentPath = data;
    },
    setCurrentPage(state, data) {
      state.currentPage = data;
    },
    setAllPages(state, pages) {
      state.allPages = pages;
    },
    setCurrentPageType(state, type) {
      state.currentPageType = type;
    },
    setCollectionData: (state, data) => {
      state.collectionData = data;
    },
  },
  actions: {
    fetchPrimaryData({ commit, dispatch, getters }, page) {
      // The API shapes this response server-side based on `page` — it returns exactly the
      // blocks this page needs. (Previously selected client-side with OData $select/$expand,
      // which the WAF rejects with a 403.)
      return new Promise((resolve, reject) => {
        axios.get(`/core/spastartupdata/primary/${page}`)
          .then((res) => {
            // Pages
            commit('setAllPages', res.data.allPages);

            // Countries
            commit('countries/setAllCountries', res.data.allCountries, { root: true });

            // Properties
            commit('properties/setAllproperties', res.data.allProperties.properties, { root: true });

            if (['results', 'all'].includes(page)) {
              // Amenity Filtering Groups
              commit('filterbar/setFilteredAllAmenities', res.data.allAmenityFilteringGroups, { root: true });
            }

            if (['results', 'villa', 'all'].includes(page)) {
              // Currencies
              commit('currencies/setAllCurrencies', res.data.allCurrencies, { root: true });
              if ($cookies.get('currentCurrencyId')) {
                commit('currencies/setCurrentCurrencyId', $cookies.get('currentCurrencyId'), { root: true });
              }
            }

            if (page === 'all') {
              // Lists
              commit('lists/setAllLists', res.data.allLists, { root: true });

              // Experiences
              commit('experiences/setAllExperiences', res.data.allExperiences, { root: true });

              // Experience Groups
              commit('experiences/setAllExperienceGroups', res.data.allExperienceGroups, { root: true });

              // Blog Pages
              commit('blogs/setAllBlogArticlePages', res.data.allBlogPages, { root: true });

              // Blog Tags
              commit('blogs/setAllBlogTags', res.data.allBlogTags, { root: true });

              // Blog Regions
              commit('blogs/setAllBlogRegions', res.data.allBlogRegions, { root: true });

              // HeardAboutUsTypes
              commit('enquiries/setAllHeardAboutUsSources', res.data.allHeardAboutUsSources, { root: true });

              // Press Pages
              commit('presspages/setAllPressPages', res.data.allPressPages, { root: true });
            }

            // Using the prefetched data find the current page
            dispatch('fetchPageByPath', getters.currentPath);

            // Set/restore shorlist
            if (window.$cookies.get('currentshortlist')) {
              const shortlistIDs = window.$cookies.get('currentshortlist');
              const shortlist = res.data.allProperties.properties.filter((p) => shortlistIDs.includes(p.id));

              if (shortlist.length > 0) {
                window.vue1.$store.commit('common/updateShortlist', shortlist);
              }
            }

            resolve(res.data);
          })
          .catch((err) => {
            console.log('Error getting start up data : ', err);
            reject(err);
          });
      });
    },

    fetchSecondaryData({ commit, dispatch, getters }, page) {
      // As above — the API returns the deferred blocks appropriate to `page`.
      return new Promise((resolve, reject) => {
        axios.get(`/core/spastartupdata/secondary/${page}`)
          .then((res) => {
            if (['home', 'villa'].includes(page)) {
              // Amenity Filtering Groups
              commit('filterbar/setFilteredAllAmenities', res.data.allAmenityFilteringGroups, { root: true });
            }

            if (['home'].includes(page)) {
              // Currencies
              commit('currencies/setAllCurrencies', res.data.allCurrencies, { root: true });
              if ($cookies.get('currentCurrencyId')) {
                commit('currencies/setCurrentCurrencyId', $cookies.get('currentCurrencyId'), { root: true });
              }
            }

            if (['home', 'results', 'villa'].includes(page)) {
              // Lists
              commit('lists/setAllLists', res.data.allLists, { root: true });

              // Experiences
              commit('experiences/setAllExperiences', res.data.allExperiences, { root: true });

              // Experience Groups
              commit('experiences/setAllExperienceGroups', res.data.allExperienceGroups, { root: true });

              // Blog Pages
              commit('blogs/setAllBlogArticlePages', res.data.allBlogPages, { root: true });

              // Blog Tags
              commit('blogs/setAllBlogTags', res.data.allBlogTags, { root: true });

              // Blog Regions
              commit('blogs/setAllBlogRegions', res.data.allBlogRegions, { root: true });

              // HeardAboutUsTypes
              commit('enquiries/setAllHeardAboutUsSources', res.data.allHeardAboutUsSources, { root: true });

              // Press Pages
              commit('presspages/setAllPressPages', res.data.allPressPages, { root: true });
            }

            resolve(res.data);
          })
          .catch((err) => {
            console.log('Error getting start up data : ', err);
            reject(err);
          });
      });
    },
    // fetchSPAStartupData({ commit, dispatch, getters }) {
    //   const startTime = performance.now();

    //   let odata = '$select=*';
    //   odata += '&$expand=allPages($select=id,parentPageId,templateid,httpStatusCode;$expand=languageSpecificCollection($select=heading1,heading2,metaDescription,metaKeywords,StructuredSchema,title,menuName),paths($select=path))';
    //   odata += '&$expand=allCountries($select=*;$expand=regions($select=*;$expand=subRegions($expand=regionPlaces($select=*))))';
    //   odata += '&$expand=allProperties($expand=*)';
    //   odata += '&$expand=allLists($select=*)';
    //   odata += '&$expand=allExperiences($select=id,name,CMSRelativeUrl)';
    //   odata += '&$expand=allExperienceGroups($select=id,parentid,title,cmsRelativeUrl)';
    //   odata += '&$expand=allAmenityFilteringGroups($select=id,name,allowFiltering,live,deleted)';
    //   odata += '&$expand=allBlogPages($select=id,name,imagePath,heroBlog,thumbImagePath,thumbImageAltText,regionId,CMSRelativeURL,featuredBlog1,featuredBlog2,categoryId;$expand=tags($select=id,name),languageSpecificBlogs($select=title,introtext))';
    //   odata += '&$expand=allBlogTags($select=id,name,imagePath,image2Path,pageTitle,blogTagCMSRelativeURL,featuredBlogId,isBlogCategory,imageAltTag,image2AltTag,blogHomeCat1,blogHomeCat2;$expand=languageSpecificTags($select=description,introTitle,heading,headingText,languageId,metaDescription,metaKeywords,structuredSchema))';
    //   odata += '&$expand=allBlogRegions($select=id,name)';
    //   odata += '&$expand=allCurrencies($select=id,code,name,sign,symbol,rate)';
    //   odata += '&$expand=allHeardAboutUsSources($select=name,description,description_HeardAboutUs_OtherTextBox,show_HeardAboutUs_OtherTextBox)';
    //   odata += '&$expand=allPressPages($select=id,title,introText,cmsRelativeURL,publisherName;$expand=properties($select=propertyId))';

    //   return new Promise((resolve, reject) => {
    //     axios.get(`/core/spastartupdata?${odata}`)
    //       .then((res) => {

    //         // Pages
    //         commit('setAllPages', res.data.allPages);

    //         // Countries
    //         commit('countries/setAllCountries', res.data.allCountries, { root: true });

    //         // Properties
    //         commit('properties/setAllproperties', res.data.allProperties.properties, { root: true });

    //         // Lists
    //         commit('lists/setAllLists', res.data.allLists, { root: true });

    //         // Experiences
    //         commit('experiences/setAllExperiences', res.data.allExperiences, { root: true });

    //         // Experience Groups
    //         commit('experiences/setAllExperienceGroups', res.data.allExperienceGroups, { root: true });

    //         // Amenity Filtering Groups
    //         commit('filterbar/setFilteredAllAmenities', res.data.allAmenityFilteringGroups, { root: true });

    //         // Blog Pages
    //         commit('blogs/setAllBlogArticlePages', res.data.allBlogPages, { root: true });

    //         // Blog Tags
    //         commit('blogs/setAllBlogTags', res.data.allBlogTags, { root: true });

    //         // Blog Regions
    //         commit('blogs/setAllBlogRegions', res.data.allBlogRegions, { root: true });

    //         // Currencies
    //         commit('currencies/setAllCurrencies', res.data.allCurrencies, { root: true });
    //         if ($cookies.get('currentCurrencyId')) {
    //           commit('currencies/setCurrentCurrencyId', $cookies.get('currentCurrencyId'), { root: true });
    //         }

    //         // HeardAboutUsTypes
    //         commit('enquiries/setAllHeardAboutUsSources', res.data.allHeardAboutUsSources, { root: true });

    //         // Press Pages
    //         commit('presspages/setAllPressPages', res.data.allPressPages, { root: true });

    //         // Using the prefetched data find the current page
    //         dispatch('fetchPageByPath', getters.currentPath);

    //         // Set/restore shorlist
    //         if (window.$cookies.get('currentshortlist')) {
    //           const shortlistIDs = window.$cookies.get('currentshortlist');
    //           const shortlist = res.data.allProperties.properties.filter((p) => shortlistIDs.includes(p.id));

    //           if (shortlist.length > 0) {
    //             window.vue1.$store.commit('common/updateShortlist', shortlist);
    //           }
    //         }

    //         const endTime = performance.now();
    //         console.log(`Call to fetchSPAStartupData took ${endTime - startTime} milliseconds`, performance.now());
    //         resolve(res.data);
    //       })
    //       .catch((err) => {
    //         console.log('Error getting start up data : ', err);
    //         reject(err);
    //       });
    //   });
    // },

    // fetchAllPages({ commit, dispatch, getters }) {
    //  // axios.get('/cms/pages')
    //  let odata = '$select=id,parentPageId,templateid,httpStatusCode';
    //  // odata += '&$expand=modules'
    //  odata += '&$expand=paths($select=path)'; // ($filter=language eq \'en\')'
    //  odata += '&$expand=languageSpecificCollection($select=heading1,metaDescription,metaKeywords,StructuredSchema,title,menuName)';
    //  axios.get(`/cms/pages/lang/en?${odata}`)
    //    .then((res) => {
    //      console.log(res.data);
    //      commit('setAllPages', res.data);
    //      dispatch('fetchPageByPath', getters.currentPath);
    //    });
    // },

    fetchPageByPath({ commit, state, dispatch, getters, rootGetters }, to) {
      // load the new page
      commit('setCurrentPath', to);

      // check if it is a CMS URL
      const page = getters.getPageByURL(to !== '/' ? to : '');

      if (page) {
        dispatch('handleFetchResponse', { page, type: 'cms' });
      }
      else {
        // check if it is a Villa URL
        const prop = rootGetters['properties/getProperyByURL'](to);

        if (prop) {
          if ((['it', 'ita'].includes(rootGetters['common/getOfficeStatus'].countryCode) && prop.hideforitaly === true) ||
            (['gr'].includes(rootGetters['common/getOfficeStatus'].countryCode) && prop.hideforgreece === true))
          {
            // Villa as set not to show in browser country
            dispatch('redirectToHome');
          } else {
            dispatch('handleFetchResponse', { page, type: 'villa', entityId: prop.id });
          }
        }
        else {
          // check if it is a collection/list URL
          const list = rootGetters['lists/getListByURL'](to);
          if (list) {
            dispatch('handleFetchResponse', { page, type: 'collection', entityId: list.id });
          }
          else {
            // check if it is a Experience URL
            const experience = rootGetters['experiences/getExperienceByURL'](to);
            if (experience) {
              // console.log('found experience ' + experience.id + ' ' + to)
              dispatch('handleFetchResponse', { page, type: 'experience', entityId: experience.id });
            } else {
              // check if it is a Experience Group URL
              const experienceGroup = rootGetters['experiences/getExperienceGroupByURL'](to);
              if (experienceGroup) {
                // console.log('found experience group ' + experienceGroup.id + ' ' + to);
                dispatch('handleFetchResponse', { page, type: 'experiencegroup', entityId: experienceGroup.id });
              } else {
                // check if it is a Press Page URL
                const pressPage = rootGetters['presspages/getPressPageByURL'](to);
                if (pressPage) {
                  dispatch('handleFetchResponse', { page, type: 'press', entityId: pressPage.id });
                } else {
                  // check if it is a Blog Article Page URL
                  const blogArticlePage = rootGetters['blogs/getBlogArticlePageByURL'](to);
                  if (blogArticlePage) {
                    dispatch('handleFetchResponse', { page, type: 'blogarticle', entityId: blogArticlePage.id });
                  } else {
                    // check if it is a Blog Tag Page URL
                    const blogTagPage = rootGetters['blogs/getBlogTagByURL'](to);
                    if (blogTagPage) {
                      dispatch('handleFetchResponse', { page, type: 'blogtag', entityId: blogTagPage.id });
                    } else {
                      // if no page found then try and load it directly from API
                      axios.get('/cms/pages/modules/bypath', { params: { path: (to !== '/' ? to : '') } })
                        .then((res) => {
                          dispatch('handleFetchResponse', { page: res.data, type: null, entityId: res.data.entityId });
                        })
                        .catch((error) => {
                          // still now page found then show the 404 page
                          if (error.response != null && (error.response.status === 404 || error.response.status === 410)) {
                            dispatch('show404');
                          }
                        });
                    }
                  }
                }
              }
            }
          }
        }
      }

      // refresh JWT token on each page request to keep the users session alive for another 20 minutes
      dispatch('users/refreshToken', null, { root: true });
    },

    handleFetchResponse({
      commit, state, dispatch, getters, rootGetters,
    }, data) {
      // if no type then try determine it from the page object
      if (!data.type && data.page) {
        if (data.page.id === state.villaPageId) data.type = 'villa';
        else if (data.page.id === state.resultsPageId) data.type = 'collection';
        else if (data.page.id === state.experiencePageId) data.type = 'experience';
        else if (data.page.id === state.experienceGroupPageId) data.type = 'experiencegroup';
        else if (data.page.id === state.pressPageId) data.type = 'press';
        else if (data.page.id === state.blogArticlePageId) data.type = 'blogarticle';
        else if (data.page.id === state.blogTagHomePageId) data.type = 'blogtag';
        else data.type = 'cms';
      }
      commit('setCurrentPageType', data.type);

      // reset current list on each page request
      commit('lists/setCurrentList', null, { root: true });

      if (state.currentPageType === 'cms') {
        if ([404, 410].includes(data.page.httpStatusCode)) {
          // the page http Status Code is 404 or 410 so display page not found
          dispatch('show404');
        }
        else if ([301, 302].includes(data.page.httpStatusCode)) {
          // the page http Status Code is 301 or 302 so redirect to the correct url
          $router.push({ path: data.page.paths[0].path });
          window.scrollTo(0, 0);
        }
        else {
          commit('setCurrentPage', data.page);
          // below is list of template Ids for which we request modules by path (appSettings.json APIRecachingService.CMSPageTemplateIdsForRefresh needs to be kept in sync with this list)
          if ([1, 2, 3, 15, 24, 38, 42, 63, 33, 65, 66, 75, 76].includes(data.page.templateId)) {
            // fetch the page modules via api for these templates
            dispatch('modules/fetchModulesByPath', state.currentPath, { root: true })
              .then((res) => {
                // Indicate to prerender.io that the page is complete
                dispatch('pages/setPreRenderDone', null, { root: true });
              });
          }
          // no need to fetch modules for these templates cms templates
          else {
            // Indicate to prerender.io that the page is complete
            dispatch('pages/setPreRenderDone', null, { root: true });
          }
        }
      }
      else if (state.currentPageType === 'villa') {
        // set the current page to the View Villa CMS page
        commit('setCurrentPage', getters.getPageById(state.villaPageId));
        commit('properties/setCurrentPropertyId', data.entityId, { root: true });
      }
      else if (state.currentPageType === 'collection') {
        if (getters.getCollectionData === null || (!!getters.getCollectionData && getters.getCollectionData.listId !== data.entityId)) {
          // Wait for FetchListById to return before changing to Results.vue template
          dispatch('lists/fetchListById', { id: data.entityId, forceReload: true }, { root: true }).then((res) => {
            // set the current page to the Results CMS page
            commit('setCurrentPage', getters.getPageById(state.resultsPageId));
            commit('setCollectionData', res);
            // Indicate to prerender.io that the page is complete
            dispatch('pages/setPreRenderDone', null, { root: true });
          });
        } else {
          // make sure that the CurrentList state is set (call with ForceReload = false, we don't want to make too many API calls when SearchFilters triggers this)
          dispatch('lists/fetchListById', { id: data.entityId, forceReload: false }, { root: true }).then((res) => { });
        }
      } else if (state.currentPageType === 'experience') {
        // set the current page to the Experience page
        commit('setCurrentPage', getters.getPageById(state.experiencePageId));
        // fetch and set the current experience experience
        dispatch('experiences/fetchExperienceById', data.entityId, { root: true }).then((res) => {
          // Indicate to prerender.io that the page is complete
          dispatch('pages/setPreRenderDone', null, { root: true });
        });
      } else if (state.currentPageType === 'experiencegroup') {
        // set the current page to the Experience group page
        commit('setCurrentPage', getters.getPageById(state.experienceGroupPageId));
        commit('experiences/setCurrentExperienceGroupId', data.entityId, { root: true });
      } else if (state.currentPageType === 'press') {
        // set the current page to the Press page
        commit('setCurrentPage', getters.getPageById(state.pressPageId));
        // fetch and set the current PressPage object
        dispatch('presspages/fetchPressPageById', data.entityId, { root: true }).then((res) => {
          // Indicate to prerender.io that the page is complete
          dispatch('pages/setPreRenderDone', null, { root: true });
        });
      } else if (state.currentPageType === 'blogarticle') {
        // set the current page to the Blog Article page
        commit('setCurrentPage', getters.getPageById(state.blogArticlePageId));
        commit('blogs/setCurrentBlogArticleId', data.entityId, { root: true });
        // fetch and set the current Blog object
        // dispatch('blogs/fetchBlogArticlePageById', data.entityId, { root: true }).then(res => {
        //  // Indicate to prerender.io that the page is complete
        //  dispatch('pages/setPreRenderDone', null, { root: true })
        // })
      } else if (state.currentPageType === 'blogtag') {
        // set the current page to the Press page
        commit('setCurrentPage', getters.getPageById(state.blogTagHomePageId));
        // fetch and set the current Blog object
        dispatch('blogs/fetchBlogTagById', data.entityId, { root: true }).then((res) => {
          // Indicate to prerender.io that the page is complete
          dispatch('pages/setPreRenderDone', null, { root: true });
        });
      }
    },

    setPreRenderDone({
      commit, state, dispatch, getter, rootGetters,
    }) {
      setTimeout(() => {
        window.prerenderReady = true;
      }, 3000);
    },
    show404({
      commit, state, dispatch, getters,
    }) {
      dispatch('fetchPageByPath', getters.getPageURLById(13));
    },
    redirectToLogin({
      commit, state, dispatch, getters, rootGetters,
    }) {
      $router.push({ path: rootGetters['applinks/getLink']('page', state.loginPageId).url });
      window.scrollTo(0, 0);
    },
    redirectToDashboard({
      commit, state, dispatch, getters, rootGetters,
    }) {
      $router.push({ path: rootGetters['applinks/getLink']('page', state.dashboardPageId).url });
      window.scrollTo(0, 0);
    },
    redirectToHome({
      commit, state, dispatch, getters,
    }) {
      $router.push({ path: '/' });
      window.scrollTo(0, 0);
    },
  },
};
